module.exports = __webpack_public_path__ + "static/media/icsa-cgi-logo.eb92f30c.svg";